import { useEffect, useState } from "react";

import { Row, Col, Button, Typography } from "antd";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
const profile = [
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        key={0}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
            fill="#111827"
        />
    </svg>,
];

const toggler = [
    <svg
        width="20"
        height="20"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        key={0}
    >
        <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" />
    </svg>,
];

function Header({
    placement,
    name,
    subName,
    onPress,
    handleSidenavColor,
    handleSidenavType,
    handleFixedNavbar,
}) {
    // state
    const [userName, setUserName] = useState("");
    // useEffect
    useEffect(() => {
        http.get(`${config.parkopoloApi}/api/User/detail`)
            .then((res) => {
                setUserName(`${res.data.firstName} ${res.data.lastName}`);
            })
            .catch((err) => {
                console.log(err);
            });
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Row gutter={[24, 0]}>
                <Col span={24} md={6}>
                    <div className="ant-page-header-heading">
                        <span
                            className="ant-page-header-heading-title"
                            style={{ textTransform: "capitalize" }}
                        >
                            {subName.replace("/", "") === "geo"
                                ? "مدیریت ژئویونیت"
                                : subName.replace("/", "") === "placeCategories"
                                ? "مدیریت دسته بندی مکان ها"
                                : subName.replace("/", "") ===
                                  "contentCategories"
                                ? "مدیریت دسته بندی محتوا"
                                : subName.replace("/", "") === "place"
                                ? "مدیریت مکان ها"
                                : subName.replace("/", "") === "addPlace"
                                ? "اضافه کردن مکان جدید"
                                : subName.replace("/", "") === "content"
                                ? "مدیریت محتوا"
                                : subName.replace("/", "") === "addContent"
                                ? "اضافه کردن محتوا جدید"
                                : subName.replace("/", "") === "linkestan"
                                ? "مدیریت لینکستان"
                                : subName.replace("/", "") === "editLink"
                                ? "ویرایش لینک"
                                : subName.replace("/", "") === "addLink"
                                ? "اضافه کردن لینک جدید"
                                : subName.replace("/", "") === "linkComments"
                                ? "مدیریت کامنت های لینکستان"
                                : subName.replace("/", "") === "news"
                                ? "مدیریت اخبار"
                                : subName.replace("/", "") === "addNews"
                                ? "اضافه کردن خبر جدید"
                                : subName.replace("/", "") === "editNews"
                                ? "ویرایش خبر"
                                : subName.replace("/", "") === "newsComments"
                                ? "مدیریت کامنت های اخبار"
                                : subName.replace("/", "") === "events"
                                ? "مدیریت رویداد ها"
                                : subName.replace("/", "") === "editEvent"
                                ? "ویرایش رویداد"
                                : subName.replace("/", "") === "eventComments"
                                ? "مدیریت کامنت های رویداد"
                                : subName.replace("/", "") === "addEvent"
                                ? "اضافه کردن رویداد جدید"
                                : subName.replace("/", "") === "complaints"
                                ? "مدیریت شکایات"
                                : subName.replace("/", "") === "feedBack"
                                ? "مدیریت نظرسنجی"
                                : subName.replace("/", "") === "addFeedBack"
                                ? "اضافه کردن نظرسنجی"
                                : subName.replace("/", "") === "editFeedBack"
                                ? "ویرایش نظرسنجی"
                                : subName.replace("/", "") === "interactions"
                                ? "مدیریت پیامک"
                                : subName.replace("/", "") === "notice"
                                ? "مدیریت اعلان ها"
                                : subName.replace("/", "") === "admin"
                                ? "مدیریت ادمین ها"
                                : subName.replace("/", "") ===
                                  "travelSuggestion"
                                ? "مدیریت پیشنهاد سفر"
                                : subName.replace("/", "") ===
                                  "addTravelSuggestion"
                                ? "اضافه کردن پیشنهاد سفر"
                                : subName.replace("/", "") ===
                                  "editTravelSuggestion"
                                ? "ویرایش پیشنهاد سفر"
                                : subName.replace("/", "") ===
                                  "travelSuggestionComments"
                                ? "مدیریت کامنت های پیشنهاد سفر"
                                : subName.replace("/", "") === "contentComments"
                                ? "مدیریت کامنت های محتوا"
                                : subName.replace("/", "") === "placeComments"
                                ? "مدیریت کامنت های مکان"
                                : subName.replace("/", "") === "discount"
                                ? "مدیریت تخفیفستان"
                                : subName.replace("/", "") === "addDiscount"
                                ? "اضافه کردن تخفیف جدید"
                                : subName.replace("/", "") === "editDiscount"
                                ? "ویرایش تخفیف"
                                : subName.replace("/", "") === "gallery"
                                ? "مدیریت نگارخانه"
                                : subName.replace("/", "") === "addGallery"
                                ? "اضافه کردن مورد جدید"
                                : subName.replace("/", "") === "editGallery"
                                ? "ویرایش مورد انتخاب شده"
                                : subName.replace("/", "") === "ads"
                                ? "مدیریت تبلیغات"
                                : subName.replace("/", "") ===
                                  "addAdvertisement"
                                ? "اضافه کردن تبلیغ جدید"
                                : subName.replace("/", "") ===
                                  "editAdvertisement"
                                ? "ویرایش تبلیغ"
                                : subName.replace("/", "") === "analytics"
                                ? "گزارش گیری"
                                : null}
                        </span>
                    </div>
                </Col>
                <Col span={24} md={18} className="header-control">
                    <Button
                        type="link"
                        className="sidebar-toggler"
                        onClick={() => onPress()}
                    >
                        {toggler}
                    </Button>

                    <div
                        style={{
                            display: "flex",
                            gap: "1rem",
                            alignItems: "center",
                        }}
                    >
                        <Typography.Paragraph style={{ margin: "0" }}>
                            {profile} {userName}
                        </Typography.Paragraph>
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default Header;
